import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import { toastOptions } from "../common/utils/toasterOptions";
import { sendTimesheetRecordNotification } from "../http/requests/project-admin";
import { setTableLoader } from "../redux/actions";
import { UserType } from "../redux/actions/user";


function* workerSendTimesheetRecordNotification(){
  try{
    yield put(setTableLoader(true));
    const response = yield call(
      sendTimesheetRecordNotification
    );
    toast.success("Timesheet record email has been successfully queued.", toastOptions);
    yield put(setTableLoader(false));
  } catch(err){
    toast.error(err.data?.errorMessage || "Failed to send timesheet record notification", toastOptions);
    yield put(setTableLoader(false));
  }
}

export function* sendTimesheetRecordNotificationSaga() {
  yield takeLatest(
    UserType.SEND_TIMESHEET_RECORD_NOTIFICATION,
    workerSendTimesheetRecordNotification
  );
};
